import { render, staticRenderFns } from "./jobPostings.vue?vue&type=template&id=726d2479"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726d2479')) {
      api.createRecord('726d2479', component.options)
    } else {
      api.reload('726d2479', component.options)
    }
    module.hot.accept("./jobPostings.vue?vue&type=template&id=726d2479", function () {
      api.rerender('726d2479', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/jobPostings.vue"
export default component.exports